import React, { useReducer } from "react";

const initialLayerState = {
  layersList: [],
  layerStatus: {},
  addLayer: (layerID) => {},
  removeLayer: (layerID) => {},
  setLayerLoading: (layerID, isLoading) => {},
};

const LayerContext = React.createContext();

// const LayerProvider = (props) => {
//   const [layers, setLayers] = React.useState({})
//   const value = [layers, setLayers]
//   return <LayerContext.Provider value={value} {...props} />
// }

function useLayer() {
  const context = React.useContext(LayerContext)
  if (!context) {
    throw new Error(`useLayer must be used within a CountProvider`)
  }
  return context
}



// //To generate buttons
// const layerIDs = [

// ]

// const TodoListContext = React.createContext();
//Initial State and Actions


const actions = {
  ADD_LAYER: "ADD_LAYER",
  REMOVE_LAYER: "REMOVE_LAYER",
  TOGGLE_COMPLETED: "TOGGLE_COMPLETED",
  SET_LAYER_LOADING: "SET_LAYER_LOADING"
};

const layerReducer = (state, action) => {
  const { type, id } = action
  switch (type) {
    case actions.ADD_LAYER:
      if (state.layersList.some((layer) => layer.id === action.id)) {
        return state;
      }
      return {
        ...state,
        layersList: [
          ...state.layersList,
          {
            id: action.id,
            label: action.id,
            completed: false
          }
        ]
      };
    case actions.REMOVE_LAYER: {
      const filteredLayer = state.layersList.filter(
        (layer) => layer.id !== action.id
      );
      return {
        ...state,
        layersList: filteredLayer
      };
    }
    case actions.SET_LAYER_LOADING: {
      return {
        ...state,
        layerStatus: {
          ...state.layerStatus,
          [action.id]: {
            ...state.layerStatus[action.id],
            loading: action.isLoading
          }
        }
      };
    }
    // case actions.TOGGLE_COMPLETED: {
    //   const updatedTodoList = state.layersList.map((todoItem) =>
    //     layer.layerID === action.layerID
    //       ? { ...layer, completed: !todoItem.completed }
    //       : todoItem
    //   );
    //   return { todoList: updatedTodoList };
    // }
    default:
      return state;
  }
};

const LayerProvider = ({ children }) => {
  const [state, dispatch] = useReducer(layerReducer, initialLayerState);

  const value = {
    layersList: state.layersList,
    layerStatus: state.layerStatus,
    addLayer: (id) => {
      dispatch({ type: actions.ADD_LAYER, id });
    },
    removeLayer: (id) => {
      dispatch({ type: actions.REMOVE_LAYER, id });
    },
    setLayerLoading: (id, isLoading) => {
      dispatch({ type: actions.SET_LAYER_LOADING, id, isLoading });
    },
    markAsCompleted: (id) => {
      dispatch({ type: actions.TOGGLE_COMPLETED, id }); //boolean - state
    }
  };

  return (
    <LayerContext.Provider value={value}>
      {children}
    </LayerContext.Provider>
  );
};

export {
  LayerContext,
  LayerProvider,
  useLayer
}
